import {AiOutlineInstagram,AiFillPhone,AiOutlineMail, AiOutlineFacebook, AiOutlineTwitter} from 'react-icons/ai'


const data = [

    // {id: 1, icon:<AiOutlineInstagram/>, title: 'Instagram'},
  
    // {id: 3, icon:<AiOutlineTwitter/>, title: 'Twitter' },
    // {id: 4, icon:<AiOutlineMail/>, title: 'elevate@gmail.com' },
    {id: 1, icon:<AiOutlineFacebook/>, title: 'Facebook', url: 'https://facebook.com/DViews360'},
    {id: 2, icon:<AiFillPhone/>, title: '+2347065 712 975', url:''}
]

export default data;